module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAeCAYAAAA2Lt7lAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABHSURBVHgB7c/BCQAhDETR2WUL2dK0MzvTTjQIgnh1jv/BQMhhQiQAgFeNdFPqKn0F3Hq2OUV+ebRIOQ90ec3ub1tkeT8ATAYv3BgWl9prOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-equal.png
// module id = 2703
// module chunks = 0